import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import VisitorGallery from './pages/VisitorGallery';
import NotFound from './pages/NotFound';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

// Home route with smart redirection
const HomeRedirect = () => {
  const { isAuthenticated, loading } = useAuth();
  
  // Show loading when checking authentication status
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Redirect to admin dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/admin/generate-qr" />;
  }
  
  // Otherwise redirect to login
  return <Navigate to="/admin/login" />;
};

// The main app content - needs to be wrapped in AuthProvider to use useAuth hook
function AppContent() {
  return (
    <AppContainer>
      <Router>
        <Routes>
          {/* Visitor Route - Accessed via QR code with unique token */}
          <Route path="/gallery/:token" element={<VisitorGallery />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/*" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Default Routes */}
          <Route path="/" element={<HomeRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AppContainer>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
